<template>
  <div class="splashscreen Login">
    <b-row class="main" align-v="center">
      <b-col cols="10" md="5" xl="4" class="logo mx-auto align-top">
        <div class="flex">
          <img :src="require('@/assets/imgs/logo.png')" alt="ACK POS" />
          <span>{{ AppName }}</span>
        </div>
      </b-col>
      <b-col cols="8" md="5" xl="3" class="mx-auto align-top">
        <span class="fs-10 text-white" v-show="false">{{ Logs }}</span>
        <b-form @submit.prevent="FormSubmit()" id="LoginForm">
          <input type="text" name="username" style="position:fixed; top:-100px;" />
          <input type="password" name="password" style="position:fixed; top:-100px;" />
          <b-form-group label-for="ack1">
            <b-form-input
              class="active ack1"
              @focus="Focused('LoginUsername', 'ack1', 'LoginForm');"
              id="ack1"
              v-model="LoginUsername"
              type="text"
              required
              placeholder="KULLANICI ADI"
              autocomplete="off"
              aria-autocomplete="off"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="forack3" label-for="ack2">
            <b-form-input
              :class="['ack3', (ack2focus) ? 'focus' : '']"
              v-model="LoginPassword"
              type="password"
              placeholder="PIN KODU"
              tabindex="-1"
              autocomplete="off"
              aria-autocomplete="off"
            ></b-form-input>
          </b-form-group>
          <b-form-group class="forack2" label-for="ack2">
            <b-form-input
              class="ack2 active"
              @focus="ack2focus = true; Focused('LoginPassword', 'ack2', 'LoginForm');"
              @blur="ack2focus = false;"
              @keypress.enter.prevent="FormSubmit(); return false;"
              id="ack2"
              v-model="LoginPassword"
              v-focus
              type="text"
              required
              autocomplete="off"
              aria-autocomplete="off"
            ></b-form-input>
          </b-form-group>
          <Keyboard type="Numbers" />
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Keyboard from "@/Components/Keyboard";

function SetInputFilter(textbox, inputFilter) {
  [
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mouseup",
    "select",
    "contextmenu",
    "drop"
  ].forEach(function(event) {
    textbox.addEventListener(event, function() {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      }
    });
  });
}

export default {
  name: "Login",
  components: {
    Keyboard
  },
  data() {
    return {
      AppName: "demo/1234",
      ack2focus: false,
      Logs: {},
      OldLoginUsername: ""
    };
  },
  computed: {
    ...mapState(["LoginUsername", "LoginPassword", "AutomaticLogin"]),
    LoginUsername: {
      get: function() {
        return this.$store.state.LoginUsername;
      },
      set: function(n) {
        localStorage.setItem("LoginUsername", String(n.trim()));

        this.$store.dispatch("SetData", {
          Key: "LoginUsername",
          Value: n.trim()
        });
      }
    },
    LoginPassword: {
      get: function() {
        return this.$store.state.LoginPassword;
      },
      set: async function(n) {
        const Replaced = n.replace(/[^0-9]/g, "");

        await this.$store.dispatch("SetData", {
          Key: "LoginPassword",
          Value: Replaced
        });

        await this.TryAutoLogin();
      }
    },
    form() {
      return {
        LoginUsername: this.$store.state.LoginUsername,
        LoginPassword: this.$store.state.LoginPassword
      };
    }
  },
  methods: {
    Focused(Data, El, Form) {
      this.$store.dispatch("SetFocusedData", { Data, El, Form });
    },
    FormSubmit() {
      this.$store.dispatch("SendForm", "Login");
    },
    async TryAutoLogin() {
      localStorage.setItem("LoginUsername", String(this.LoginUsername));

      if (
        this.LoginUsername === this.OldLoginUsername &&
        this.LoginPassword.length === parseInt(this.AutomaticLogin)
      ) {
        this.FormSubmit();
      }
    }
  },
  async mounted() {
    this.$store.dispatch("GetConf");

    this.Focused("LoginPassword", "ack2", "Login");

    if (localStorage.getItem("LoginUsername")) {
      await this.$set(this, "OldLoginUsername", localStorage.LoginUsername);
      this.$store.dispatch("SetData", {
        Key: "LoginUsername",
        Value: localStorage.getItem("LoginUsername")
      });
    }

    if (localStorage.getItem("AutomaticLogin")) {
      this.$store.dispatch("SetData", {
        Key: "AutomaticLogin",
        Value: localStorage.getItem("AutomaticLogin")
      });
    }

    SetInputFilter(document.getElementById("ack2"), function(Value) {
      return /^\d*$/.test(Value);
    });

    this.$store.subscribe(async mutation => {
      if (["SetData", "Up", "Del"].indexOf(mutation.type) !== -1) {
        await this.$nextTick();
        await this.$forceUpdate();
        await this.TryAutoLogin();
      }
    });

    if (localStorage.AppName) {
      await this.$set(this, "AppName", localStorage.AppName);
    }
  }
};
</script>

<style>
.ack1,
.ack2,
.ack3 {
  font-family: monospace !important;
  font-size: 16px !important;
  font-weight: 900 !important;
}
.ack1 ::placeholder,
.ack2 ::placeholder,
.ack3 ::placeholder {
  color: #fff;
}
.ack2 {
  color: transparent !important;
  caret-color: #a2671b;
  background: transparent !important;
}
.ack3.focus {
  background: #444 !important;
}
#app .form-control.ack2:focus {
  background: none;
}
.forack2 {
  position: relative;
  top: -54px;
}
</style>
